import React from 'react';
import { observer } from 'mobx-react';
import { NavigationCard, AudienceCard, FeatureCard, ToggleCard } from 'components/Card';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';

export const Page: React.FC = observer(() =>
{
  const { uiStore } = useStore();

  return (
    <article className="page dashboard">
      <h1>{uiStore.labels.pages.dashboard.title}</h1>
      <section className="cards">
        <NavigationCard to={paths.buildFeatureListPath()}>
          <FeatureCard title={uiStore.labels.pages.dashboard.cards.feature.title} description={uiStore.labels.pages.dashboard.cards.feature.description} />
        </NavigationCard>
        <NavigationCard to={paths.buildToggleListPath()}>
          <ToggleCard title={uiStore.labels.pages.dashboard.cards.toggle.title} description={uiStore.labels.pages.dashboard.cards.toggle.description}/>
        </NavigationCard>
        <NavigationCard to={paths.buildAudiencePath()}>
          <AudienceCard title={uiStore.labels.pages.dashboard.cards.audience.title} description={uiStore.labels.pages.dashboard.cards.audience.description}/>
        </NavigationCard>
      </section>
    </article>
  );
});